import { RailtownAI } from ".";

// @ts-expect-error we need to put RailtownAI on the window object
window.RailtownAI = new RailtownAI();
